import { useEffect, useState, useContext } from 'react';

import { RightOutlined } from '@ant-design/icons';

import { LayoutContext } from '../../baseLayout/provider';

const SearchListPop = ({ hidePop, searchKeyWord, handleClickKeyWord, searchList }) => {
  const { resourceData } = useContext(LayoutContext);
  const [associationalWordList, setAssociationalWordList] = useState([]); // 联想词
  const listClassName = 'text-[12px] leading-[16px] mb-[10px]';

  useEffect(() => {
    setAssociationalWordList(highlightKeyWord(searchList, searchKeyWord));
  }, [searchKeyWord, searchList]);

  function highlightKeyWord(dataList, keyWord) {
    return dataList
      .map((data) => {
        if (data.type === 'brand' || data.type === 'catalog') {
          data.wordArr[0].renderWord = data.wordArr[0].itemValue.replace(
            keyWord.toUpperCase(),
            '<span>' + keyWord.toUpperCase() + '</span>'
          );
        } else {
          data.renderWord = data.word.replace(keyWord.toUpperCase(), '<span>' + keyWord.toUpperCase() + '</span>');
        }
        return data;
      })
      .slice(0, 10); // 只显示10条
  }

  function globalSearch({ word, keyWordIdx, type, tipType }) {
    handleClickKeyWord({ clickedkeyWord: word, keyWordIdx, type, tipType });
    hidePop();
  }

  return (
    <>
      <ul className={listClassName}>
        {associationalWordList.map((item, i) => {
          const liClassName = i === 9 ? 'mb-[10px]' : '';
          let content = (
            <li
              onClick={() => globalSearch({ ...item, keyWordIdx: i, type: 'suggestion', tipType: item.type })}
              className={`${liClassName} cursor-pointer h-[32px] px-[20px] flex items-center justify-between hover:bg-[#E8F5FC] hover:text-lcBlue`}
              key={i}
            >
              <span className="*:text-lcBlue" dangerouslySetInnerHTML={{ __html: item.renderWord }}></span>
            </li>
          );

          if (item && item.word && (item.word.includes('~catalogId') || item.word.includes('~brandId'))) {
            let urlText = 'catalog';
            if (item.wordArr[1] && item.wordArr[1].itemKeyArr && item.wordArr[1].itemKeyArr[0] == 'brandId') {
              //品牌
              urlText = 'brand';
            }
            content = (
              <a
                href={`${resourceData?.projectConfigVO?.lcscListUrl}/${urlText}/${item.wordArr[1].itemKeyArr[1]}.html${window.isMro ? '?mro=1' : ''}`}
                target="_blank"
                className={`${liClassName} h-[32px] px-[20px] flex items-center justify-between hover:bg-[#E8F5FC] hover:text-lcBlue`}
                key={i}
              >
                <span className="*:text-lcBlue" dangerouslySetInnerHTML={{ __html: item.wordArr[0].renderWord }}></span>
                <span className="text-[#56657F] flex items-center">
                  <span className="mr-[6px]">进入{urlText === 'brand' ? '品牌' : '类目'}</span>
                  <RightOutlined style={{ fontSize: '9px' }} />
                </span>
              </a>
            );
          }
          return content;
        })}
      </ul>
    </>
  );
};

export default SearchListPop;
